import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledCircleIcon = styled(FontAwesomeIcon)<{ $color: 'error' | 'success' }>`
  color: ${({ theme, $color = 'success' }) => theme.colors[$color].main};
`;
